/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { PropertyMatrixBaseServiceV2 } from '../property-matrix-base-service-v-2';
import { PropertyMatrixConfigurationV2 } from '../property-matrix-configuration-v-2';
import { PropertyMatrixStrictHttpResponseV2 } from '../property-matrix-strict-http-response-v-2';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ContractDetailDto } from '../models/contract-detail-dto';

@Injectable({
  providedIn: 'root',
})
export class ContractDetailService extends PropertyMatrixBaseServiceV2 {
  constructor(
    config: PropertyMatrixConfigurationV2,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiV1ContractDetailGetAllContractDetailsGet
   */
  static readonly ApiV1ContractDetailGetAllContractDetailsGetPath = '/api/v1/ContractDetail/GetAllContractDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1ContractDetailGetAllContractDetailsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ContractDetailGetAllContractDetailsGet$Response(params?: {
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponseV2<Array<ContractDetailDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ContractDetailService.ApiV1ContractDetailGetAllContractDetailsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<Array<ContractDetailDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1ContractDetailGetAllContractDetailsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1ContractDetailGetAllContractDetailsGet(params?: {
    context?: HttpContext
  }
): Observable<Array<ContractDetailDto>> {

    return this.apiV1ContractDetailGetAllContractDetailsGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<Array<ContractDetailDto>>) => r.body as Array<ContractDetailDto>)
    );
  }

  /**
   * Path part for operation apiV1ContractDetailAddContractDetailsPost
   */
  static readonly ApiV1ContractDetailAddContractDetailsPostPath = '/api/v1/ContractDetail/AddContractDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1ContractDetailAddContractDetailsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1ContractDetailAddContractDetailsPost$Response(params?: {
    context?: HttpContext
    body?: ContractDetailDto
  }
): Observable<PropertyMatrixStrictHttpResponseV2<ContractDetailDto>> {

    const rb = new RequestBuilder(this.rootUrl, ContractDetailService.ApiV1ContractDetailAddContractDetailsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<ContractDetailDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1ContractDetailAddContractDetailsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1ContractDetailAddContractDetailsPost(params?: {
    context?: HttpContext
    body?: ContractDetailDto
  }
): Observable<ContractDetailDto> {

    return this.apiV1ContractDetailAddContractDetailsPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<ContractDetailDto>) => r.body as ContractDetailDto)
    );
  }

}
